import WithSkeletonLoader from './withSkeletonLoader';

export default WithSkeletonLoader;
